<template>
  <div id="boardInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>我的展位</el-breadcrumb-item>
      <el-breadcrumb-item>特装展位</el-breadcrumb-item>
    </el-breadcrumb>
    <div style='margin:20px 0;font-size:16px;font-weight:bold'>手册下载</div>
    <div style="padding:0px 0 10px">
      <!-- download -->
      <el-button type="primary"><a :href="file0" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">CAC2025 参展商指南</a></el-button>
      <el-button type="primary"><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">特装展位参展商须知</a></el-button>
      <el-button type="primary"><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">CAC2025 搭建商服务手册</a></el-button>
      <el-button type="primary"><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">CAC2025 参展展品（国内）运输指南</a></el-button>
    </div>
    <div style="margin-top:10px;padding-bottom:100px">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          prop="text1"
          width='210'
          label="重要事项"
         >
        </el-table-column>
        <el-table-column
          prop="text2"
          label="事项说明"
          >
        </el-table-column>
        <el-table-column
          prop="text3"
          width="190"
          label="截止日期">
        </el-table-column>
        <el-table-column prop="more" label="更多详情" align="center" width="190">
          <template slot-scope="scope">
            <el-button type="primary" style="width:160px" v-if="scope.row.more =='点击填写'" @click="toLink(scope.row.address)">{{scope.row.more}}</el-button>
            <el-button type="primary" style="width:160px" v-else><a :href="scope.row.address" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">{{scope.row.more}}</a></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
import img01 from '@/assets/img01.png'
import img02 from '@/assets/img02.png'
import img03 from '@/assets/img03.png'
export default {
  name: 'boardInfo',
  data () {
    return {
      file0:'./CAC2025参展商指南－中文版.pdf',
      file1:'./特装展位参展商须知.pdf',
      file2:'./CAC2025 搭建商手册.docx',
      file3:'./CAC2025 参展展品（国内）运输指南.docx',
      tableData:[
        {
          text1:"电子会刊及展商名录",
          text2:"在“公司信息”模块下“电子会刊信息”中提交的名称将用于现场展商名录",
          text3:"会刊截止：2025年2月20日",
          more:'点击填写',
          type:'',
          address:'/magezine'
        },
        {
          text1:"参展证",
          text2:"在“参展证申请”模块下提交参展人员信息用于制作参展证件",
          text3:"2025年3月16日",
          more:'点击填写',
          type:'',
          address:'/card'
        },
        {
          text1:"注册搭建商、管理费、押金、水电气等租赁、图纸申报",
          text2:"请登录主场搭建服务平台专区进行申请，布展期间临时申请将无法受理。",
          text3:"2025年1月22日",
          more:'点击申请链接',
          type:'',
          address:'http://CAC.best-expo.com.cn'
        },
        {
          text1:"保险",
          text2:"参照右侧文档，完成扫码投保。特装报图时需上传保单，才能完成图纸审核，进馆搭建。",
          text3:"2025年1月22日",
          more:'点击查看下载文档',
          type:'',
          address:'./展览会责任险.pdf'
        },
        {
          text1:"超高展位审图",
          text2:"按照展馆规定，超过4.5米(含4.5米)的室内单、双层展位均需进行超高展位搭建审图",
          text3:"2025年1月22日",
          more:'点击查看下载文档',
          type:'',
          address:'./超高展位审图.pdf'
        },
        {
          text1:"施工证",
          text2:"展馆NH馆（北大厅二楼）凭押金单办理施工证",
          text3:"2025年3月14-16日",
          more:'点击申请链接',
          type:'',
          address:'http://www.neccsh.com/cecsh/watchexhi/applicationflow.jspx'
        },
        {
          text1:"车辆进馆轮候证及车证办理",
          text2:"在展馆北登录厅主场运输服务台办理停车场轮候证（30元/证/次），北登录厅主场搭建服务台领取押金单，前往NH馆（北大厅二楼）制证中心办理装卸区车辆通行证和装卸区车辆引导证",
          text3:"2025年3月15-16日",
          more:'点击查看下载文档',
          type:'',
          address:'./特装车辆进馆轮候证及车证办理.pdf'
        },
        {
          text1:"消防三件套租用",
          text2:"根据展馆要求特装企业必须租用消防三件套，确保展期展位消防安全，办理地点：6.1馆3号门、8.1馆3号门、2.1馆3号门和北厅安全服务中心租赁点办理。",
          text3:"2025年3月15-16日",
          more:'点击查看下载文档',
          type:'',
          address:'./消防三件套租用.pdf'
        }
      ]

    }
  },
  mounted() {
    // this.getsaasfield()
  },
  methods: {
    toLink(str){
      this.$router.replace(str)
      // this.$router.push({ name:str})
      // window.location.href = str

    }
  }
}
</script>
<style lang="less">
#boardInfo{
  font-size:14px;

  @media screen and (max-width:540px){
    .el-form-item__content{
      width: 240px;
    }
    .btns{
      text-align: center;
    }
  }
}
</style>

